<template>
  <p v-if="error" class="text-danger small">{{ error }}</p>
</template>

<script>
export default {
  name: "error-p",
  props: ["error"],
};
</script>

<style scoped>
p {
  margin: 2px;
}
</style>